import { BotDictionaryItem } from '@/models/dictionary/bot';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { IBookmakerDictionaryApi } from '@/types';

export const useBotDictionary = defineStore('botDictionary', () => {
    const items = shallowRef<BotDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(items);

    // actions
    function setData(data: IBookmakerDictionaryApi[]) {
        console.time('set-bot-dictionary');
        items.value = data.map((item) => new BotDictionaryItem(item));
        console.timeEnd('set-bot-dictionary');
    }

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
